import { useQuery } from "@tanstack/react-query"
import * as myRitualityService from "../services/my-rituality.service"

export function useSuggestedRituals(limit: number = 5) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["suggested-rituals", limit],
    queryFn: () => myRitualityService.getRandomRituals(limit),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    rituals: data ?? [],
    isLoading,
    error,
  }
}
